import { Component } from '@angular/core';
import { environment } from '@env/environment';

@Component({
  selector: 'app-download-section',
  templateUrl: './download-section.component.html',
  styleUrls: ['./download-section.component.scss'],
})
export class DownloadSectionComponent {
  mobileImageUrl = `${environment.cdnBaseURL}public/images/mobile.png`;
  bgdownloadImageUrl = `${environment.cdnBaseURL}public/images/bgdownload.jpg`;
  iosImageUrl = `${environment.cdnBaseURL}public/images/ios.png`;
  playstoreImageUrl = `${environment.cdnBaseURL}public/images/playstore.png`;

  constructor() {}
}
